export default __webpack_public_path__ + "static/media/alert_quota.22587ddc.svg";